import React from "react";
import { Link } from "react-router-dom";

/**
 * Site-wide footer — appears on every content page (via HomeShell / Layout).
 * Four-column grid on desktop, single column on mobile.
 * Uses the site's neutral tokens (#E7EAF0 border · #5B6478 muted · #0B1220 primary).
 */
const COL_TITLE = "text-[10px] uppercase tracking-[0.14em] font-bold text-[#0B1220] mb-3";
const LINK_CLS  = "block text-[12.5px] text-[#5B6478] hover:text-[#0B1220] transition-colors py-1";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16 border-t border-[#E7EAF0] bg-white"
      data-testid="site-footer"
    >
      <div className="max-w-[1920px] mx-auto pl-[88px] pr-6 sm:pr-8 lg:pr-10 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 max-w-[1080px]">
          {/* Product */}
          <div>
            <div className={COL_TITLE}>Product</div>
            <Link to="/wikifi"    className={LINK_CLS} data-testid="footer-wikifi">Wikifi Workspace</Link>
            <Link to="/algorithm" className={LINK_CLS} data-testid="footer-algorithm">Algorithms</Link>
            <Link to="/prompts"   className={LINK_CLS} data-testid="footer-prompts">Prompt Library</Link>
            <Link to="/pricing"   className={LINK_CLS} data-testid="footer-pricing">Pricing</Link>
          </div>

          {/* Directory */}
          <div>
            <div className={COL_TITLE}>Directory</div>
            <Link to="/"            className={LINK_CLS} data-testid="footer-directory">All Tools</Link>
            <Link to="/agents"      className={LINK_CLS} data-testid="footer-agents">AI Agents</Link>
            <Link to="/submit"      className={LINK_CLS} data-testid="footer-submit">Submit a Tool</Link>
            <Link to="/methodology" className={LINK_CLS} data-testid="footer-methodology">Methodology</Link>
          </div>

          {/* Company */}
          <div>
            <div className={COL_TITLE}>Company</div>
            <Link to="/about"   className={LINK_CLS} data-testid="footer-about">About</Link>
            <Link to="/contact" className={LINK_CLS} data-testid="footer-contact">Contact</Link>
            <Link to="/terms"   className={LINK_CLS} data-testid="footer-terms">Terms of Service</Link>
            <Link to="/privacy" className={LINK_CLS} data-testid="footer-privacy">Privacy Policy</Link>
          </div>

          {/* Follow */}
          <div>
            <div className={COL_TITLE}>Follow</div>
            <a href="https://twitter.com/wikificial" target="_blank" rel="noopener noreferrer" className={LINK_CLS} data-testid="footer-twitter">X (Twitter)</a>
            <a href="https://github.com/wikificial" target="_blank" rel="noopener noreferrer" className={LINK_CLS} data-testid="footer-github">GitHub</a>
            <a href="https://linkedin.com/company/wikificial" target="_blank" rel="noopener noreferrer" className={LINK_CLS} data-testid="footer-linkedin">LinkedIn</a>
            <a href="mailto:contact@wikifi.app" className={LINK_CLS} data-testid="footer-email">contact@wikifi.app</a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#E7EAF0] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 max-w-[1080px]">
          <div className="text-[11.5px] text-[#5B6478]">
            © {year} Wikificial. The Encyclopedia of AI. All rights reserved.
          </div>
          <div className="text-[11.5px] text-[#8A93A6]">
            Made for the builders. Always updating.
          </div>
        </div>
      </div>
    </footer>
  );
}
